import { Search } from 'lucide-react';
import { Input } from '@/components/ui-kit/input';

interface NotesSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function NotesSearch({ value, onChange }: NotesSearchProps) {
  return (
    <div className="relative max-w-md">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        type="text"
        placeholder="Search Notes"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        className="pl-10 bg-card"
      />
    </div>
  );
}
